const LABELS = {
  fr: {
    progress: "Question {n} sur {t}", back: "Retour", next: "Suivant", hint: "Plusieurs choix possibles.",
    q: {
      hob: "Sur quelle plaque cuisinez-vous ?", people: "Pour combien de personnes cuisinez-vous en général ?", dishes: "Que voulez-vous cuisiner au wok ?",
      pace: "Comment aimez-vous cuisiner ?", freq: "Combien de fois par semaine allez-vous sortir votre wok ?",
    },
    o: {
      hob: { gas: "Gaz", induction: "Induction", ceramic: "Vitrocéramique", electric: "Plaques électriques" },
      people: { "1": "1 personne", "2": "2 personnes", "3-4": "3 ou 4 personnes", "5-6": "5 ou 6 personnes", "7+": "7 ou plus" },
      dishes: { stirfry: "Sautés", fry: "Poêlées", braise: "Mijotés", deepfry: "Fritures", steam: "Cuisson vapeur" },
      pace: { normal: "Vite, à feu vif", slow: "Doucement, en mijotant", any: "Un peu des deux" },
      freq: { low: "Une fois ou moins", mid: "Deux ou trois fois", high: "Quatre fois ou plus" },
    },
    title: "Notre choix pour vous", best: "Le plus adapté", also: "Autre bon choix", answers: "Vos réponses", edit: "Modifier mes réponses",
    fits: "Compatible {hob}", hobs: { gas: "gaz", induction: "induction", ceramic: "vitrocéramique", electric: "plaques électriques" }, lid: "Avec couvercle",
    people: { "1": "une personne", "2": "deux personnes", "3-4": "3 ou 4 personnes", "5-6": "5 ou 6 personnes", "7+": "7 personnes ou plus" },
    reason: {
      size: "{d} cm, la bonne taille pour {people}", closest: "{d} cm, la taille la plus proche en stock",
      lid_free: "Couvercle offert, pour mijoter et cuire à la vapeur", lid_variant: "Avec son couvercle, pour mijoter et cuire à la vapeur",
      season_low: "Pas de culottage à faire, pratique si vous ne cuisinez au wok que de temps en temps",
      season_high: "Utilisé souvent, il se couvre d'une couche antiadhésive naturelle",
    },
    why: {
      carbon: "Chauffe vite et supporte le feu très vif.", cast: "Garde longtemps la chaleur, bien pour mijoter et frire.",
      steel: "Ne rouille pas et se nettoie facilement.", alu: "Léger en main et vite chaud.", coated: "Avec son revêtement antiadhésif, vous cuisinez avec très peu de matière grasse.",
    },
    add: "Ajouter au panier", added: "Ajouté au panier", both: "Ajouter les deux au panier", error: "L'ajout n'a pas fonctionné. Réessayez.",
    offer_tag: "Le 2e à -35% !", offer: "Prenez les deux, le deuxième wok est à -35 %.",
    empty: "Nous n'avons pas de wok de l'offre en stock pour cette plaque en ce moment.", all: "Voir tous les woks de l'offre",
  },
  en: {
    progress: "Question {n} of {t}", back: "Back", next: "Next", hint: "Choose as many as you like.",
    q: {
      hob: "What kind of hob do you cook on?", people: "How many people do you usually cook for?", dishes: "What do you want to cook in your wok?",
      pace: "How do you like to cook?", freq: "How often will you use your wok each week?",
    },
    o: {
      hob: { gas: "Gas", induction: "Induction", ceramic: "Ceramic", electric: "Electric hotplates" },
      people: { "1": "1 person", "2": "2 people", "3-4": "3 or 4 people", "5-6": "5 or 6 people", "7+": "7 or more" },
      dishes: { stirfry: "Stir-frying", fry: "Pan-frying", braise: "Braising", deepfry: "Deep-frying", steam: "Steaming" },
      pace: { normal: "Fast, over high heat", slow: "Slowly, letting it simmer", any: "A bit of both" },
      freq: { low: "Once or less", mid: "Two or three times", high: "Four times or more" },
    },
    title: "Our pick for you", best: "Best match", also: "Also a good pick", answers: "Your answers", edit: "Change my answers",
    fits: "Works on {hob} hobs", hobs: { gas: "gas", induction: "induction", ceramic: "ceramic", electric: "electric" }, lid: "With lid",
    people: { "1": "one person", "2": "two people", "3-4": "3 or 4 people", "5-6": "5 or 6 people", "7+": "7 people or more" },
    reason: {
      size: "{d} cm, the right size for {people}", closest: "{d} cm, the closest size in stock",
      lid_free: "Free lid, for braising and steaming", lid_variant: "Sold with its lid, for braising and steaming",
      season_low: "No seasoning needed, handy if you only cook with it now and then",
      season_high: "Cook with it often and it builds up its own non-stick layer",
    },
    why: {
      carbon: "Heats up fast and takes very high heat.", cast: "Holds its heat for a long time, good for braising and deep-frying.",
      steel: "Won't rust and is easy to keep clean.", alu: "Light in the hand and quick to heat.", coated: "The non-stick coating lets you cook with very little oil.",
    },
    add: "Add to cart", added: "Added to cart", both: "Add both to cart", error: "That didn't work. Please try again.",
    offer_tag: "2nd wok 35% off!", offer: "Take both and you get 35% off the second wok.",
    empty: "We don't have a wok from the offer in stock for this hob right now.", all: "See all the woks in the offer",
  },
  nl: {
    progress: "Vraag {n} van {t}", back: "Terug", next: "Volgende", hint: "Kies er zo veel als je wilt.",
    q: {
      hob: "Op welke kookplaat kook je?", people: "Voor hoeveel personen kook je meestal?", dishes: "Wat wil je in je wok maken?",
      pace: "Hoe kook je het liefst?", freq: "Hoe vaak gebruik je je wok per week?",
    },
    o: {
      hob: { gas: "Gas", induction: "Inductie", ceramic: "Keramische plaat", electric: "Elektrische plaat" },
      people: { "1": "1 persoon", "2": "2 personen", "3-4": "3 of 4 personen", "5-6": "5 of 6 personen", "7+": "7 of meer" },
      dishes: { stirfry: "Roerbakken", fry: "Bakken", braise: "Stoven", deepfry: "Frituren", steam: "Stomen" },
      pace: { normal: "Snel op hoog vuur", slow: "Rustig laten sudderen", any: "Allebei" },
      freq: { low: "Eén keer of minder", mid: "Twee of drie keer", high: "Vier keer of vaker" },
    },
    title: "Onze keuze voor jou", best: "Past het best", also: "Ook een goede keuze", answers: "Je antwoorden", edit: "Antwoorden aanpassen",
    fits: "Geschikt voor {hob}", hobs: { gas: "gas", induction: "inductie", ceramic: "keramisch", electric: "elektrisch" }, lid: "Met deksel",
    people: { "1": "één persoon", "2": "twee personen", "3-4": "3 of 4 personen", "5-6": "5 of 6 personen", "7+": "7 personen of meer" },
    reason: {
      size: "{d} cm, de juiste maat voor {people}", closest: "{d} cm, de dichtstbijzijnde maat op voorraad",
      lid_free: "Gratis deksel, om te stoven en te stomen", lid_variant: "Met deksel, om te stoven en te stomen",
      season_low: "Inbranden hoeft niet, handig als je hem niet vaak gebruikt",
      season_high: "Kook je er vaak mee, dan krijgt hij vanzelf een natuurlijke antiaanbaklaag",
    },
    why: {
      carbon: "Wordt snel heet en kan tegen hoog vuur.", cast: "Houdt de warmte lang vast, fijn om te stoven en te frituren.",
      steel: "Roest niet en is makkelijk schoon te houden.", alu: "Licht in de hand en snel warm.", coated: "Met de antiaanbaklaag bak je met weinig olie.",
    },
    add: "In winkelwagen", added: "Toegevoegd", both: "Allebei in winkelwagen", error: "Dat lukte niet. Probeer het nog eens.",
    offer_tag: "2e wok 35% korting!", offer: "Neem ze allebei en je krijgt 35% korting op de tweede wok.",
    empty: "Voor deze kookplaat hebben we nu geen wok uit de aanbieding op voorraad.", all: "Bekijk alle woks uit de aanbieding",
  },
  de: {
    progress: "Frage {n} von {t}", back: "Zurück", next: "Weiter", hint: "Du kannst mehrere wählen.",
    q: {
      hob: "Auf welchem Herd kochst du?", people: "Für wie viele Personen kochst du meistens?", dishes: "Was möchtest du im Wok zubereiten?",
      pace: "Wie kochst du am liebsten?", freq: "Wie oft nimmst du den Wok pro Woche?",
    },
    o: {
      hob: { gas: "Gas", induction: "Induktion", ceramic: "Ceranfeld", electric: "Elektroherd mit Platten" },
      people: { "1": "1 Person", "2": "2 Personen", "3-4": "3 oder 4 Personen", "5-6": "5 oder 6 Personen", "7+": "7 oder mehr" },
      dishes: { stirfry: "Unter Rühren braten", fry: "Braten", braise: "Schmoren", deepfry: "Frittieren", steam: "Dämpfen" },
      pace: { normal: "Schnell bei starker Hitze", slow: "Langsam schmoren lassen", any: "Beides" },
      freq: { low: "Einmal oder seltener", mid: "Zwei- oder dreimal", high: "Viermal oder öfter" },
    },
    title: "Unsere Wahl für dich", best: "Passt am besten", also: "Auch eine gute Wahl", answers: "Deine Antworten", edit: "Antworten ändern",
    fits: "Geeignet für {hob}", hobs: { gas: "Gas", induction: "Induktion", ceramic: "Ceran", electric: "Elektroherd" }, lid: "Mit Deckel",
    people: { "1": "eine Person", "2": "zwei Personen", "3-4": "3 oder 4 Personen", "5-6": "5 oder 6 Personen", "7+": "7 Personen oder mehr" },
    reason: {
      size: "{d} cm, die richtige Größe für {people}", closest: "{d} cm, die nächstliegende Größe auf Lager",
      lid_free: "Deckel gratis dabei, zum Schmoren und Dämpfen", lid_variant: "Mit Deckel, zum Schmoren und Dämpfen",
      season_low: "Kein Einbrennen nötig, praktisch, wenn du ihn nur ab und zu nimmst",
      season_high: "Kochst du oft damit, bildet er von selbst eine natürliche Antihaftschicht",
    },
    why: {
      carbon: "Wird schnell heiß und hält hohe Temperaturen aus.", cast: "Hält die Wärme lange, gut zum Schmoren und Frittieren.",
      steel: "Rostet nicht und ist leicht zu pflegen.", alu: "Leicht in der Hand und schnell heiß.", coated: "Mit der Antihaftbeschichtung brätst du mit wenig Öl.",
    },
    add: "In den Warenkorb", added: "Hinzugefügt", both: "Beide in den Warenkorb", error: "Das hat nicht geklappt. Versuch es noch einmal.",
    offer_tag: "2. Wok -35 %!", offer: "Nimm beide, dann bekommst du 35 % Rabatt auf den zweiten Wok.",
    empty: "Für diesen Herd haben wir gerade keinen Wok aus dem Angebot auf Lager.", all: "Alle Woks aus dem Angebot ansehen",
  },
  da: {
    progress: "Spørgsmål {n} af {t}", back: "Tilbage", next: "Næste", hint: "Du kan vælge flere.",
    q: {
      hob: "Hvilken kogeplade laver du mad på?", people: "Hvor mange laver du som regel mad til?", dishes: "Hvad vil du lave i din wok?",
      pace: "Hvordan laver du helst mad?", freq: "Hvor tit bruger du din wok om ugen?",
    },
    o: {
      hob: { gas: "Gas", induction: "Induktion", ceramic: "Keramisk kogeplade", electric: "Elektrisk kogeplade" },
      people: { "1": "1 person", "2": "2 personer", "3-4": "3 eller 4 personer", "5-6": "5 eller 6 personer", "7+": "7 eller flere" },
      dishes: { stirfry: "Wokstegning", fry: "Stegning", braise: "Gryderetter", deepfry: "Friturestegning", steam: "Dampning" },
      pace: { normal: "Hurtigt ved høj varme", slow: "Langsomt ved lav varme", any: "Begge dele" },
      freq: { low: "Én gang eller sjældnere", mid: "To eller tre gange", high: "Fire gange eller oftere" },
    },
    title: "Vores valg til dig", best: "Passer bedst", also: "Også et godt valg", answers: "Dine svar", edit: "Ret dine svar",
    fits: "Egnet til {hob}", hobs: { gas: "gas", induction: "induktion", ceramic: "keramisk kogeplade", electric: "elektrisk kogeplade" }, lid: "Med låg",
    people: { "1": "én person", "2": "to personer", "3-4": "3 eller 4 personer", "5-6": "5 eller 6 personer", "7+": "7 personer eller flere" },
    reason: {
      size: "{d} cm, den rigtige størrelse til {people}", closest: "{d} cm, den nærmeste størrelse på lager",
      lid_free: "Gratis låg, til gryderetter og dampning", lid_variant: "Med låg, til gryderetter og dampning",
      season_low: "Skal ikke brændes ind, praktisk hvis du kun bruger den en gang imellem",
      season_high: "Bruger du den tit, danner den selv et naturligt slip-let-lag",
    },
    why: {
      carbon: "Bliver hurtigt varm og tåler høje temperaturer.", cast: "Holder længe på varmen, god til gryderetter og friture.",
      steel: "Ruster ikke og er nem at holde ren.", alu: "Let i hånden og hurtigt varm.", coated: "Med slip-let-belægningen kan du stege med lidt olie.",
    },
    add: "Læg i kurv", added: "Lagt i kurven", both: "Læg begge i kurven", error: "Det lykkedes ikke. Prøv igen.",
    offer_tag: "2. wok -35 %!", offer: "Tag dem begge, så får du 35 % rabat på den anden wok.",
    empty: "Til denne kogeplade har vi ingen wok fra tilbuddet på lager lige nu.", all: "Se alle wokke i tilbuddet",
  },
};

const VALUES = {
  fr: {
    label: { material: "Matière", coating: "Revêtement", diameter: "Diamètre", season: "Culottage", lid: "Couvercle", hob: "Feux compatibles" },
    hob: { gas: "Gaz", induction: "Induction", ceramic: "Vitrocéramique", electric: "Électrique" },
    season: "Nécessaire", noseason: "Pas nécessaire", lid: "Inclus", lid_word: "couvercle", no_lid_word: "sans", coated: /^antiadhésif$|^céramique/i,
    lid_only: /couvercle uniquement|couvercle seul/i,
    material: [["cast", /fonte/i], ["carbon", /\bfer\b|carbone/i], ["steel", /inox/i], ["alu", /alumin/i]],
  },
  en: {
    label: { material: "Material", coating: "Coating", diameter: "Diameter", season: "Seasoning", lid: "Lid", hob: "Suitable hobs" },
    hob: { gas: "Gas", induction: "Induction", ceramic: "Ceramic", electric: "Electric" },
    season: "Required", noseason: "Not needed", lid: "Included", lid_word: "lid", no_lid_word: "without", coated: /^non-stick$|^ceramic/i,
    lid_only: /only lid|lid only/i,
    material: [["cast", /cast iron/i], ["carbon", /iron|carbon/i], ["steel", /stainless/i], ["alu", /alumin/i]],
  },
  nl: {
    label: { material: "Materiaal", coating: "Coating", diameter: "Diameter", season: "Inbranden", lid: "Deksel", hob: "Geschikt voor" },
    hob: { gas: "Gas", induction: "Inductie", ceramic: "Keramisch", electric: "Elektrisch" },
    season: "Nodig", noseason: "Niet nodig", lid: "Inbegrepen", lid_word: "deksel", no_lid_word: "zonder", coated: /anti|kerami/i,
    lid_only: /alleen deksel/i,
    material: [["cast", /gietijzer/i], ["carbon", /ijzer|koolstof/i], ["steel", /roestvrij/i], ["alu", /alumin/i]],
  },
  de: {
    label: { material: "Material", coating: "Beschichtung", diameter: "Durchmesser", season: "Einbrennen", lid: "Deckel", hob: "Geeignet für" },
    hob: { gas: "Gas", induction: "Induktion", ceramic: "Ceran", electric: "Elektro" },
    season: "Erforderlich", noseason: "Nicht nötig", lid: "Inklusive", lid_word: "deckel", no_lid_word: "ohne", coated: /antihaft|keramik/i,
    lid_only: /nur deckel/i,
    material: [["cast", /gusseisen/i], ["carbon", /eisen|carbon/i], ["steel", /edelstahl/i], ["alu", /alumin/i]],
  },
  da: {
    label: { material: "Materiale", coating: "Belægning", diameter: "Diameter", season: "Indbrænding", lid: "Låg", hob: "Egnet til" },
    hob: { gas: "Gas", induction: "Induktion", ceramic: "Keramisk", electric: "Elektrisk" },
    season: "Nødvendig", noseason: "Ikke nødvendig", lid: "Medfølger", lid_word: "låg", no_lid_word: "uden", coated: /slip|kerami/i,
    lid_only: /kun låg/i,
    material: [["cast", /støbejern/i], ["carbon", /jern|kulstof/i], ["steel", /rustfri/i], ["alu", /alumin/i]],
  },
};

const QUESTIONS = [
  { key: "hob", options: ["gas", "induction", "ceramic", "electric"] },
  { key: "people", options: ["1", "2", "3-4", "5-6", "7+"] },
  { key: "dishes", multi: true, options: ["stirfry", "fry", "braise", "deepfry", "steam"] },
  { key: "pace", options: ["normal", "slow", "any"] },
  { key: "freq", options: ["low", "mid", "high"] },
];
const TARGET_CM = { "1": 24, "2": 28, "3-4": 32, "5-6": 34, "7+": 36 };
const SIZE_OK_CM = 2;
const DISH = {
  stirfry: { carbon: 2, steel: 1, cast: 0.5, alu: 0.5 },
  fry: { coated: 1.5, steel: 1, carbon: 1 },
  braise: { cast: 2, steel: 1, lid: 1 },
  deepfry: { cast: 2, carbon: 1 },
  steam: { lid: 2, steel: 1 },
};
const PACE = { slow: { cast: 2, lid: 1 }, normal: { carbon: 1.5 } };
const NOT_A_WOK = /set\b|sæt\b/i;
const CM = /(\d{2,3})\s?cm/i;

const svg = (body) => `<svg viewBox="0 0 32 32" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${body}</svg>`;
const ICONS = {
  hob: {
    gas: svg('<path d="M16 5c.6 3.6 5.5 6.2 5.5 11.5a5.5 5.5 0 0 1-11 0c0-2.7 1.4-4.5 2.8-5.8.1 2.2 1 3.6 2.4 4.1-.6-3.2-.6-6.5.3-9.8z"/><path d="M8 27h16"/>'),
    induction: svg('<rect x="4" y="4" width="24" height="24" rx="4"/><circle cx="16" cy="16" r="8"/><path d="M11 16c1.2-1.8 2.3-1.8 3.4 0s2.3 1.8 3.4 0 2.3-1.8 3.2 0"/>'),
    ceramic: svg('<rect x="4" y="4" width="24" height="24" rx="4"/><circle cx="16" cy="16" r="5.5"/><path d="M16 7.5v1.8M16 22.7v1.8M7.5 16h1.8M22.7 16h1.8"/>'),
    electric: svg('<circle cx="16" cy="16" r="11"/><circle cx="16" cy="16" r="7"/><circle cx="16" cy="16" r="3"/>'),
  },
  dishes: {
    stirfry: svg('<path d="M4 16h22a11 8.5 0 0 1-22 0z"/><path d="M26 16l4-2"/><circle cx="11" cy="9" r="1.4"/><circle cx="16.5" cy="6.5" r="1.4"/><circle cx="20" cy="10.5" r="1.2"/>'),
    fry: svg('<path d="M3 18h19c0 3.3-2.2 5.5-5.5 5.5h-8C5.2 23.5 3 21.3 3 18z"/><path d="M22 19.5h8"/><path d="M9 14c0-1.8 1.6-2 1.6-3.8M14.5 14c0-1.8 1.6-2 1.6-3.8"/>'),
    braise: svg('<path d="M7 14h18v9a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4z"/><path d="M5 14h22M9 11h14M14 11V8.5h4V11M7 18H4.5M25 18h2.5"/>'),
    deepfry: svg('<path d="M4 14h24a12 10 0 0 1-24 0z"/><path d="M7 17.5c2 1 4 1 6 0s4-1 6 0 4 1 6 0"/><circle cx="12" cy="21" r="1.3"/><circle cx="18" cy="22.5" r="1.6"/><circle cx="22" cy="20.5" r="1"/>'),
    steam: svg('<rect x="6" y="18" width="20" height="9" rx="2.5"/><path d="M6 22.5h20"/><path d="M11 14.5c-1.4-1.4 1.4-2.8 0-4.5M16 14.5c-1.4-1.4 1.4-2.8 0-4.5M21 14.5c-1.4-1.4 1.4-2.8 0-4.5"/>'),
  },
};
const CHECK = '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="M5.8 10.4l2.8 2.7 5.6-6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

export function texts(lang) {
  const walk = (node) => (typeof node === "string" ? [node] : Object.values(node).flatMap(walk));
  return walk(LABELS[lang]);
}

export function specs(product, lang) {
  const V = VALUES[lang];
  const raw = Object.fromEntries(product.c.map((line) => [line.split("|")[0], line.slice(line.indexOf("|") + 1)]));
  const get = (key) => raw[V.label[key]] ?? null;
  const material = get("material");
  const coating = get("coating");
  const season = get("season");
  return {
    hob: (get("hob") || "").split(",").map((h) => h.trim()).filter(Boolean),
    diameters: (get("diameter") || "").match(/\d{2,3}/g)?.map(Number) || [],
    material,
    cls: V.material.find(([, re]) => re.test(material || product.t))?.[0] || null,
    coating,
    coated: Boolean(coating && V.coated.test(coating)),
    season: season === V.season ? true : season === V.noseason ? false : null,
    lid: get("lid") === V.lid,
  };
}

function hasLid(variant, sp, lang) {
  const t = variant.t.toLowerCase();
  return sp.lid || (t.includes(VALUES[lang].lid_word) && !t.includes(VALUES[lang].no_lid_word));
}

export function variantFor(product, sp, target, wantLid, lang) {
  let best = null;
  for (const v of product.v) {
    if (!v.a || VALUES[lang].lid_only.test(v.t)) continue;
    const cm = v.t.match(CM);
    const d = cm ? Number(cm[1]) : sp.diameters.length === 1 ? sp.diameters[0] : null;
    const lid = hasLid(v, sp, lang);
    const key = [d == null ? 99 : Math.abs(d - target), wantLid && !lid ? 1 : 0];
    if (!best || key[0] < best.key[0] || (key[0] === best.key[0] && key[1] < best.key[1])) best = { v, d, lid, key };
  }
  return best;
}

function wantsLid(answers) {
  const dishes = answers.dishes || [];
  return dishes.includes("braise") || dishes.includes("steam") || answers.pace === "slow";
}

function seasonFit(sp, answers) {
  if (answers.freq === "low" && sp.season === false) return "season_low";
  if (answers.freq === "high" && sp.season === true) return "season_high";
  return null;
}

export function rank(products, answers, lang) {
  const target = TARGET_CM[answers.people] ?? 32;
  const dishes = answers.dishes || [];
  const wantLid = wantsLid(answers);
  const hob = VALUES[lang].hob[answers.hob];
  const span = Math.max(1, ...products.map((p) => p.r + 1));
  const out = [];
  for (const p of products) {
    if (!/wok/i.test(p.t) || NOT_A_WOK.test(p.t)) continue;
    const sp = specs(p, lang);
    if (!sp.hob.includes(hob)) continue;
    const pick = variantFor(p, sp, target, wantLid, lang);
    if (!pick) continue;
    const points = (table) => (table[sp.cls] || 0) + (sp.coated ? table.coated || 0 : 0) + (pick.lid ? table.lid || 0 : 0);
    let s = dishes.reduce((sum, dish) => sum + points(DISH[dish] || {}), 0) + points(PACE[answers.pace] || {});
    if (seasonFit(sp, answers)) s += 1.5;
    const gap = pick.d == null ? null : Math.abs(pick.d - target);
    s += gap == null ? -2 : -gap / 2 - (gap > SIZE_OK_CM ? 1.5 : 0);
    s += 1 - p.r / span;
    out.push({ p, sp, v: pick.v, d: pick.d, lid: pick.lid, s });
  }
  const gap = (r) => (r.d == null ? Infinity : Math.abs(r.d - target));
  const best = Math.min(...out.map(gap));
  for (const r of out) r.closest = r.d != null && gap(r) === best;
  return out.sort((a, b) => b.s - a.s);
}

export function pick(ranked) {
  if (!ranked.length) return [];
  const second = ranked.find((r) => r.sp.cls !== ranked[0].sp.cls);
  return second ? [ranked[0], second] : [ranked[0]];
}

export function reasons(r, answers, lang) {
  const L = LABELS[lang];
  const out = [fill(L.fits, { hob: L.hobs[answers.hob] })];
  const size = r.d != null && Math.abs(r.d - (TARGET_CM[answers.people] ?? 32)) <= SIZE_OK_CM ? L.reason.size : r.closest && L.reason.closest;
  if (size) out.push(fill(size, { d: r.d, people: L.people[answers.people] }));
  const why = r.sp.coated ? L.why.coated : L.why[r.sp.cls];
  if (why) out.push(why.replace(/\.$/, ""));
  const extra = wantsLid(answers) && r.lid ? (r.sp.lid ? "lid_free" : "lid_variant") : seasonFit(r.sp, answers);
  if (extra) out.push(L.reason[extra]);
  return out;
}

function esc(s) {
  return String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
}

function fill(template, values) {
  return template.replace(/\{(\w+)\}/g, (_, k) => values[k]);
}

async function addToCart(items, button, L) {
  const sections = ["auto-gifts"];
  const drawer = document.querySelector("cart-drawer");
  if (drawer?.dataset.sectionId) sections.push(drawer.dataset.sectionId);
  button.disabled = true;
  button.classList.add("is-loading");
  try {
    const res = await fetch(window.Theme?.routes?.cart_add_url || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items, sections: sections.join(",") }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || String(res.status));
    if (location.pathname.includes("/cart")) return location.reload();
    const { CartUpdatedEvent } = await import("@theme/events");
    const icon = document.querySelector("cart-icon");
    const count = icon?.getCurrentItemCount?.();
    document.dispatchEvent(new CartUpdatedEvent({}, { itemCount: count != null ? count + items.length : undefined, source: "quiz-wok", sections: data.sections }));
    if (icon?.addToCartBehavior === "notification") {
      document.dispatchEvent(new CustomEvent("toast:open", { detail: { type: "success", message: window.Theme?.translations?.addToCartNotificationMessage } }));
    }
    button.textContent = L.added;
  } catch (error) {
    console.error("quiz-wok", error);
    button.textContent = L.error;
    button.disabled = false;
  } finally {
    button.classList.remove("is-loading");
  }
}

function price(v) {
  return `<div class="rc-price">${esc(v.p)}${v.cp ? ` <s>${esc(v.cp)}</s>` : ""}</div>`;
}

function image(r, url, width) {
  return `<a class="qw-img" href="${esc(url)}" tabindex="-1" aria-hidden="true">${r.p.i ? `<img src="${esc(r.p.i)}" alt="" width="${width}" height="${width}" loading="lazy">` : ""}</a>`;
}

function hero(r, answers, L, lang) {
  const url = `${r.p.u}?variant=${r.v.id}`;
  return `<article class="qw-hero">
    ${image(r, url, 220)}
    <div class="qw-top"><p class="qw-label">${esc(L.best)}</p><h4><a href="${esc(url)}">${esc(r.p.t)}</a></h4>${price(r.v)}</div>
    <ul class="qw-why">${reasons(r, answers, lang).map((t) => `<li>${CHECK}<span>${esc(t)}</span></li>`).join("")}</ul>
    <div class="qw-buy"><button type="button" class="rc-btn qw-add" data-ids="${r.v.id}">${esc(L.add)}</button></div>
  </article>`;
}

function alt(r, answers, L) {
  const url = `${r.p.u}?variant=${r.v.id}`;
  const chips = [fill(L.fits, { hob: L.hobs[answers.hob] }), r.d && `Ø ${r.d} cm`, r.sp.material, r.sp.coated && r.sp.coating, r.lid && L.lid].filter(Boolean);
  return `<article class="qw-alt">
    ${image(r, url, 120)}
    <div class="qw-top"><p class="qw-label">${esc(L.also)}</p><h4><a href="${esc(url)}">${esc(r.p.t)}</a></h4>
      <ul class="qw-chips">${chips.map((c) => `<li>${esc(c)}</li>`).join("")}</ul>${price(r.v)}</div>
    <button type="button" class="rc-btn qw-add" data-ids="${r.v.id}">${esc(L.add)}</button>
  </article>`;
}

function mount(root) {
  const lang = root.dataset.lang;
  const L = LABELS[lang];
  const products = JSON.parse(root.querySelector("script[type='application/json']").textContent);
  const body = root.querySelector(".qw-body");
  const state = { step: 0, answers: { dishes: [] }, busy: false };

  function show(html, isResult) {
    const moved = body.childElementCount > 0;
    body.innerHTML = html;
    body.classList.toggle("is-result", Boolean(isResult));
    if (moved) body.querySelector(".qw-q")?.focus({ preventScroll: true });
    if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function question() {
    const { key, options, multi } = QUESTIONS[state.step];
    const chosen = multi ? state.answers[key] : [state.answers[key]];
    const total = QUESTIONS.length;
    const icons = ICONS[key] || {};
    show(`<p class="qw-progress">${esc(fill(L.progress, { n: state.step + 1, t: total }))}</p>
      <div class="qw-bar" aria-hidden="true"><span style="width:${((state.step + 1) / total) * 100}%"></span></div>
      <h3 class="qw-q" tabindex="-1">${esc(L.q[key])}</h3>
      ${multi ? `<p class="qw-hint">${esc(L.hint)}</p>` : ""}
      <div class="qw-options${icons[options[0]] ? " has-icons" : ""}" data-key="${key}">${options.map((o) =>
        `<button type="button" class="qw-opt" data-v="${esc(o)}" aria-pressed="${chosen.includes(o)}">${icons[o] || ""}<span>${esc(L.o[key][o])}</span></button>`).join("")}</div>
      <div class="qw-nav">
        ${state.step ? `<button type="button" class="qw-back">${esc(L.back)}</button>` : "<span></span>"}
        ${multi ? `<button type="button" class="rc-btn qw-next"${chosen.length ? "" : " disabled"}>${esc(L.next)}</button>` : ""}
      </div>`);
  }

  function result() {
    const a = state.answers;
    const picks = pick(rank(products, a, lang));
    const recap = [L.o.hob[a.hob], L.o.people[a.people], ...a.dishes.map((d) => L.o.dishes[d])];
    const offer = picks.length === 2
      ? `<div class="qw-offer"><p><span class="qw-tag">${esc(L.offer_tag)}</span> ${esc(L.offer)}</p>
         <button type="button" class="rc-btn qw-add qw-both" data-ids="${picks.map((r) => r.v.id).join(",")}">${esc(L.both)}</button></div>`
      : "";
    const found = picks.length ? hero(picks[0], a, L, lang) + (picks[1] ? alt(picks[1], a, L) : "") + offer : "";
    const empty = `<div class="qw-empty"><p>${esc(L.empty)}</p><a class="rc-btn" href="${esc(root.dataset.all)}">${esc(L.all)}</a></div>`;
    show(`<h3 class="qw-q" tabindex="-1">${esc(L.title)}</h3>
      <div class="qw-recap"><span>${esc(L.answers)}</span><ul>${recap.map((t) => `<li>${esc(t)}</li>`).join("")}</ul></div>
      ${found || empty}
      <div class="qw-nav"><button type="button" class="qw-back">${esc(L.back)}</button><button type="button" class="qw-restart">${esc(L.edit)}</button></div>`, true);
  }

  function render() {
    state.step < QUESTIONS.length ? question() : result();
  }

  body.addEventListener("click", (event) => {
    const el = event.target.closest("button");
    if (!el || state.busy) return;
    const q = QUESTIONS[state.step];
    if (el.classList.contains("qw-opt") && q.multi) {
      const list = state.answers[q.key];
      const at = list.indexOf(el.dataset.v);
      at < 0 ? list.push(el.dataset.v) : list.splice(at, 1);
      el.setAttribute("aria-pressed", String(at < 0));
      body.querySelector(".qw-next").disabled = !list.length;
      return;
    }
    if (el.classList.contains("qw-opt")) {
      state.answers[q.key] = el.dataset.v;
      body.querySelectorAll(".qw-opt").forEach((b) => b.setAttribute("aria-pressed", String(b === el)));
      state.step += 1;
      state.busy = true;
      return setTimeout(() => { state.busy = false; render(); }, 180);
    }
    if (el.classList.contains("qw-next")) state.step += 1;
    else if (el.classList.contains("qw-back")) state.step -= 1;
    else if (el.classList.contains("qw-restart")) Object.assign(state, { step: 0, answers: { dishes: [] } });
    else if (el.classList.contains("qw-add")) return addToCart(el.dataset.ids.split(",").map((id) => ({ id: Number(id), quantity: 1 })), el, L);
    else return;
    render();
  });
  render();
}

if (typeof document !== "undefined") {
  document.querySelectorAll("[data-quiz-wok]:not([data-ready])").forEach((root) => {
    root.dataset.ready = "1";
    mount(root);
  });
}
